"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWalletAdapter = useWalletAdapter;
var react_1 = require("react");
var useWallet_1 = require("./useWallet");
/**
 * Hook for accessing a specific wallet adapter by name
 *
 * @param adapterName Optional name of the wallet adapter to access
 * @returns The requested adapter or the currently selected adapter
 */
function useWalletAdapter(adapterName) {
    var _a = (0, useWallet_1.useWallet)(), wallet = _a.wallet, wallets = _a.wallets;
    return (0, react_1.useMemo)(function () {
        var _a;
        if (adapterName) {
            var adapter = ((_a = wallets.find(function (walletItem) { return walletItem.adapter.name === adapterName; })) === null || _a === void 0 ? void 0 : _a.adapter) || null;
            return adapter;
        }
        return (wallet === null || wallet === void 0 ? void 0 : wallet.adapter) || null;
    }, [wallet, wallets, adapterName]);
}
